import { ContractPerson } from "@repo/api";
import { FC } from "react";
import { PersonDetailAddress } from "./PersonDetailAddress";
import * as Styled from "./PersonsAccordion.styled";

type PersonDetailPermanentResidenceProps = {
    person: ContractPerson;
};
export const PersonDetailPermanentResidence: FC<PersonDetailPermanentResidenceProps> = ({ person }) => {
    return (
        <Styled.PersonsAccordionAddressBox>
            <PersonDetailAddress {...person.permanentAddress} />
        </Styled.PersonsAccordionAddressBox>
    );
};
